import client from './../../utils/http-client'
import {injectable} from "inversify";

export class ContactService {
    constructor() {
        this.client = client;
    }

    async sendForm(data) {
        const formData = new FormData();
        formData.append('_wpcf7', 1918);
        formData.append('_wpcf7_version', '5.8.5');
        formData.append('_wpcf7_locale', 'es_ES');
        formData.append('_wpcf7_unit_tag', 'wpcf7-f1918-p1919-o1');
        formData.append('_wpcf7_container_post', '1919');
        formData.append('your-name', data.name);
        formData.append('your-email', data.email);
        formData.append('your-subject', data.subject);
        formData.append('your-message', data.message);
        for(const fieldName in data) {
            formData.append(fieldName, data[fieldName]);
        }
        return await this.client.post('https://smile-magazine.com/wp-json/contact-form-7/v1/contact-forms/1918/feedback', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    async getContactData() {
        const response = await this.client.get('https://smile-magazine.com/wp-json/wp/v2/pages/2097');
        if(response.status !== 200) {
            return false;
        }
        return response.data;
    }
}
injectable()(ContactService);
